import { styled } from '@mui/material/styles';
import colors from '../../theme/colors';

export const Wrapper = styled('div')`
  display: flex;
  flex-direction: ${({ flexDirection }) => flexDirection};
  align-items: center;
  padding: 24px;
  gap: 24px;
  width: 100%;
  min-height: 128px;
  border-radius: 8px;
`;

export const IconWrapper = styled('div')`
  width: 64px;
  height: 64px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.neutral.shades.shade100};
  border-radius: 50%;
`;
